import { render, staticRenderFns } from "./MessagePreview.vue?vue&type=template&id=551b72d2&scoped=true"
import script from "./MessagePreview.vue?vue&type=script&lang=js"
export * from "./MessagePreview.vue?vue&type=script&lang=js"
import style0 from "./MessagePreview.vue?vue&type=style&index=0&id=551b72d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551b72d2",
  null
  
)

export default component.exports